import React, {useEffect, useRef, useState} from 'react';
import {useParams, useNavigate} from "react-router-dom";
import {useReactToPrint} from "react-to-print";
import { PrinterIcon, PencilIcon, ArrowPathIcon, ArrowLeftIcon } from '@heroicons/react/24/outline';
import CustomSpinner from "../../../pages/CustomSpinner";
import { getAnnonces } from 'src/service/annonceApi';
import { getStockagesById, updateStockage, getStockages, createStockage } from 'src/service/stockageApi';
import { notifySuccess } from 'src/service/notificationService';
import { MooveStockage } from 'src/service/annonceApi';

export default function BoxDetail() {
    let contentStock = []
    let { id } = useParams()
    const navigate = useNavigate();
    const [stock, setSotck] = useState([])
    const [boxName, setBoxName] = useState();
    const [loadingBoxContent, setLoadingBoxContent] = useState(true);
    const [update, setUpdate] = useState(false)
    const [updateName, setUpdateName] = useState("")
    const [updateLoading, setUpdateLoading] = useState(false)
    const componentRef = useRef();
    const [hoveredItem, setHoveredItem] = useState(null);
    const [previewPosition, setPreviewPosition] = useState({ x: 0, y: 0 });
    const [availableBoxes, setAvailableBoxes] = useState([]);
    const [transferringItem, setTransferringItem] = useState(null);
    const [selectedBox, setSelectedBox] = useState(null);
    const [showNewBoxDialog, setShowNewBoxDialog] = useState(false);
    const [newBoxName, setNewBoxName] = useState('');

    useEffect(() => {
        async function mount() {
            let boxName = null

            await getStockagesById(id).then(res => {
                boxName = res.boxName
                setBoxName(res.boxName)
            })

            await getAnnonces(`?status=TROUVÉ`).then(res => {
                res.map(doc => {
                    if (doc.stockage && doc.stockage.boxName) {
                        if (doc.stockage.boxName === boxName) {
                            contentStock.push(doc)
                            setSotck(contentStock)
                        }
                    }
                })
            })
            
            setLoadingBoxContent(false)
        }

        mount();
    }, [updateLoading])

    useEffect(() => {
        getStockages("?motherBox=1").then((res) => {
            setAvailableBoxes(res);
        });
    }, []);

    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
        documentTitle: 'Impression sherlook'
    });

    const handleChangeUpdateName = (event) => {
        setUpdateName(event.target.value)
    }

    const handleUpdate = () => {
        setUpdate(!update)
        setUpdateName(boxName)
    }

    const updateBoite = async () => {        
        setUpdateLoading(true)
        await updateStockage(id, {boxName: updateName})
        .then(res => {
            setUpdateLoading(false)
            setUpdate(!update)
            notifySuccess("La boite a été mise à jour !")
        })
    }

    const handleMouseEnter = (event, item) => {
        event.stopPropagation();
        
        if (event.target.closest('.action-button')) {
            setHoveredItem(null);
            return;
        }
        
        const mouseY = event.clientY;
        setPreviewPosition({
            x: event.clientX + 20,
            y: mouseY + 20
        });
        setHoveredItem(item);
    };

    const handleMouseLeave = (event) => {
        event.stopPropagation();
        setHoveredItem(null);
    };

    const handleActionMouseEnter = (event) => {
        event.stopPropagation();
        setHoveredItem(null);
    };

    const handleTransfer = (item) => {
        setTransferringItem(item);
    };

    const handleTransferConfirm = async () => {
        if (selectedBox && transferringItem) {
            try {
        
                const response = await MooveStockage(transferringItem.id, selectedBox.id);
                
                notifySuccess("L'objet a été transféré avec succès !");
                const updatedStock = stock.filter(item => item.id !== transferringItem.id);
                setSotck(updatedStock);
                setTransferringItem(null);
                setSelectedBox(null);
            } catch (error) {
                console.error("Erreur lors du transfert:", error);
                console.error("Détails de l'erreur:", {
                    message: error.message,
                    response: error.response?.data,
                    status: error.response?.status
                });
                // Afficher une notification d'erreur à l'utilisateur
                if (error.response?.status === 404) {
                    alert("Erreur : L'objet ou la boîte de destination n'existe pas.");
                } else if (error.response?.status === 403) {
                    alert("Erreur : Vous n'avez pas les permissions pour effectuer cette action.");
                } else {
                    alert("Erreur lors du transfert. Veuillez réessayer.");
                }
            }
        } else {

            alert("Veuillez sélectionner une boîte de destination.");
        }
    };

    const handleTransferCancel = () => {
        setTransferringItem(null);
        setSelectedBox(null);
    };

    const handleCreateNewBox = async () => {
        try {
            const boxData = {
                year: new Date().getFullYear(),
                month: new Date().getMonth() + 1,
                boxName: newBoxName,
                motherBox: true,
            };
            
            const response = await createStockage(false, boxData);
            setAvailableBoxes([...availableBoxes, response]);
            setSelectedBox(response);
            setShowNewBoxDialog(false);
            setNewBoxName('');
            notifySuccess("Nouvelle boite créée avec succès !");
        } catch (error) {
            console.error("Erreur lors de la création de la boite:", error);
        }
    };

    return (
        <div className="p-4">
            {loadingBoxContent ? (
                <CustomSpinner />
            ) : (
                <>
                    <div className="flex items-center justify-between mb-6">
                        <button 
                            onClick={() => navigate('/dashboard/stockage')}
                            className="flex items-center space-x-2 text-gray-700 hover:text-gray-900"
                        >
                            <ArrowLeftIcon className="w-5 h-5" />
                            <span>Retour aux boîtes</span>
                        </button>
                        <div className="flex space-x-4">
                            <button 
                                onClick={handlePrint} 
                                className="flex items-center space-x-2 text-gray-700 hover:text-gray-900"
                            >
                                <span>Imprimer</span>
                                <PrinterIcon className="w-5 h-5" />
                            </button>
                            <button 
                                onClick={handleUpdate} 
                                className="flex items-center space-x-2 text-gray-700 hover:text-gray-900"
                            >
                                <span>Modifier</span>
                                <PencilIcon className="w-5 h-5" />
                            </button>
                        </div>
                    </div>

                        <div ref={componentRef}>
                        {update && (
                            <div className="flex items-center space-x-2 mb-4">
                                <input 
                                    onChange={handleChangeUpdateName} 
                                    value={updateName} 
                                    type="text" 
                                    placeholder='Nom de la boite'
                                    className="px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                />
                                <button 
                                    onClick={updateBoite}
                                    className="px-4 py-2 border border-blue-500 text-blue-500 rounded-md hover:bg-blue-50"
                                >
                                    Enregistrer
                                </button>
                            </div>
                        )}

                        {updateLoading && (
                            <div className="w-1/10">
                                        <CustomSpinner />
                                    </div>
                        )}

                        <h1 className="text-2xl font-bold mb-4">{boxName}</h1>

                        <div className="overflow-x-auto">
                            <table className="min-w-full divide-y divide-gray-200">
                                <thead className="bg-[#1b9faa] text-white">
                                    <tr>
                                        <th className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider">ID</th>
                                        <th className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider">Lieu</th>
                                        <th className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider">Date</th>
                                        <th className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider">Catégorie</th>
                                        <th className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider">Type</th>
                                        <th className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider">Actions</th>
                                    </tr>
                                </thead>
                                <tbody className="bg-white divide-y divide-gray-200">
                                    {stock.map((item) => (
                                        <tr 
                                            key={item.id}
                                            onMouseEnter={(e) => handleMouseEnter(e, item)}
                                            onMouseLeave={handleMouseLeave}
                                            className="hover:bg-gray-50"
                                        >
                                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{item.id}</td>
                                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{item.ville}</td>
                                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{item.createdAt}</td>
                                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{item.category['name']}</td>
                                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                                {item.annonceAttributes[0] !== undefined && item.annonceAttributes[0]['attributeValue']}
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                                <button 
                                                    onClick={() => handleTransfer(item)}
                                                    onMouseEnter={handleActionMouseEnter}
                                                    className="text-[#1b9faa] hover:text-[#15808a] action-button"
                                                >
                                                    <ArrowPathIcon className="w-5 h-5" />
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                            {hoveredItem && (
                            <div 
                                className="fixed z-50 w-[300px] bg-white p-4 shadow-lg rounded-lg"
                                style={{
                                    top: previewPosition.y,
                                        left: previewPosition.x,
                                    }}
                                >
                                <img 
                                        src={hoveredItem.filePath 
                                            ? `${process.env.REACT_APP_PUBLIC_URL}/images/annonces/${hoveredItem.filePath}`
                                            : `${process.env.REACT_APP_PUBLIC_URL}/images/annonces/default/${hoveredItem.category.defaultImage}`
                                        }
                                        alt={hoveredItem.category.name}
                                    className="w-full h-[200px] object-cover rounded mb-2"
                                />
                                <p className="text-sm text-gray-600">{hoveredItem.description}</p>
                            </div>
                        )}

                            {transferringItem && (
                            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                                <div className="bg-white p-6 rounded-lg w-[400px]">
                                    <h3 className="text-lg font-semibold mb-4">Transférer l'objet</h3>
                                    <div className="space-y-4">
                                        <div className="flex space-x-2">
                                            <select 
                                                className="flex-1 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                                onChange={(e) => {
                                            
                                                    const box = availableBoxes.find(b => b.id == e.target.value);
                                                    
                                                    setSelectedBox(box);
                                                }}
                                            >
                                                <option value="">Sélectionner une boite</option>
                                                {availableBoxes
                                                    .filter(box => box.id != id) // Exclure la boîte actuelle
                                                    .map(box => (
                                                        <option key={box.id} value={box.id}>{box.boxName}</option>
                                                    ))
                                                }
                                            </select>
                                            <button
                                                    onClick={() => setShowNewBoxDialog(true)}
                                                className="px-4 py-2 border border-[#1b9faa] text-[#1b9faa] rounded-md hover:bg-[#1b9faa] hover:text-white flex items-center space-x-2"
                                            >
                                                <PencilIcon className="w-5 h-5" />
                                                <span>Nouvelle boite</span>
                                            </button>
                                        </div>
                                        <div className="flex justify-end space-x-2">
                                            <button 
                                                    onClick={handleTransferCancel}
                                                className="px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-50"
                                                >
                                                    Annuler
                                            </button>
                                            <button 
                                                    onClick={handleTransferConfirm}
                                                    disabled={!selectedBox}
                                                className="px-4 py-2 bg-[#1b9faa] text-white rounded-md hover:bg-[#15808a] disabled:opacity-50 disabled:cursor-not-allowed"
                                            >
                                                Confirmer
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                            {showNewBoxDialog && (
                            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[60]">
                                <div className="bg-white p-6 rounded-lg w-[400px]">
                                    <h3 className="text-lg font-semibold mb-4">Créer une nouvelle boite</h3>
                                    <div className="space-y-4">
                                        <input
                                            type="text"
                                            value={newBoxName}
                                            onChange={(e) => setNewBoxName(e.target.value)}
                                            placeholder="Nom de la boite"
                                            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                        />
                                        <div className="flex justify-end space-x-2">
                                            <button 
                                                onClick={() => {
                                                    setShowNewBoxDialog(false);
                                                    setNewBoxName('');
                                                }}
                                                className="px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-50"
                                            >
                                                Annuler
                                            </button>
                                            <button 
                                                onClick={handleCreateNewBox}
                                                disabled={!newBoxName}
                                                className="px-4 py-2 bg-[#1b9faa] text-white rounded-md hover:bg-[#15808a] disabled:opacity-50 disabled:cursor-not-allowed"
                                            >
                                                Créer
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            )}
                        </div>
                </>
                )}
        </div>
    );
}